import React, { useEffect, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { default as SuppliesService } from 'services/Supplies';

const SubTable = styled.table`
	width: 100%;
	
	td, th {
		border: 1px solid gray;
		text-align: center;
		padding: 8px 10px;
	}

	thead {

		tr {

			th {
				color: var(--plenoil-brown-light);
				padding: 2px 10px;
			}
		}
	}

	tbody {

		tr {

			td {

				&:first-of-type {
					text-align: left;
				}

				&:nth-child(4),
				&:nth-child(5) {
					width: 100px;
				}

				&.checked-qty-wrapper {
					position: relative;

					input {
						border: none;
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						text-align: center;
						background: transparent;
					}
				}
			}
		}
	}

	thead, tbody {
		td, th {
			
			&:first-of-type {
				border-left: 0;
			}
		}

		tr {

			&:first-of-type {
				th {
					border-top: 0;
				}
			}

			&:last-of-type {
				td {
					border-bottom: 0;
				}
			}
		}
	}

	tfoot {

		td {
			font-size: 12px !important;

			&:first-of-type {
				border-left: 0;
				border-bottom: 0;
			}

			&:last-of-type {
				border-bottom: 0;
			}
		}
	}
	
`;

export default function Details(props) {
	let id = props.id;
	let forceReloadParent = props.forceReload;

	let [forceReload, setForceReload] = useState(false);
	let [order, setOrder] = useState({});

	useEffect(() => {
		let getData = async () => {
			let data = await SuppliesService.getBCOrderTc(id);
			setOrder(data);
		}
		getData();

		return function cleanup() {
			SuppliesService.cancel();
		}
	}, [id, forceReload]);

	const setCheckedQty = (idx, value) => {
		let newProducts = [...order.products];
		newProducts[idx].checked_qty = value ? parseInt(value) : null;
		
		setOrder({
			...order,
			products: newProducts
		});
	}

	const approve = async () => {
		const c = window.confirm('¿Seguro que quieres aprobar el pedido?');
		if (!c) return;

		let result = await SuppliesService.approveBCOrderTc(id, {
			products: order.products,
			albaran: order.albaran,
			albaran_date: order.albaran_date
		});
		if (result) {
			setForceReload(Math.random());
			forceReloadParent();
		}
	}

	const cancel = async () => {
		const c = window.confirm('¿Seguro que quieres cancelar el pedido?');
		if (!c) return;

		let result = await SuppliesService.cancelBCOrderTc(id);
		if (result) {
			setForceReload(Math.random());
			forceReloadParent();
		}
	}

	return (
		<tr className="details">
			<td colSpan="100%" className="p-0">
				<div className="row">
					<div className="col-md-6">
						<SubTable>
							<thead>
								<tr>
									<th></th>
									<th>CÓDIGO</th>
									<th>UNIDADES</th>
									<th colSpan="2">COMPROBACIÓN</th>
								</tr>
							</thead>
							<tbody>
								{order?.products?.map((el, idx) => {
									let icon = null;
									if ( el.checked_qty === null ) {
										icon = <i className="bi bi-ban text-warning"></i>;
									}
									if ( el.checked_qty !== null && el.checked_qty !== el.qty ) {
										icon = <i className="bi bi-x-circle-fill text-danger"></i>;
									}
									if ( el.checked_qty !== null && el.checked_qty === el.qty ) {
										icon = <i class="bi bi-check-circle-fill text-secondary"></i>;
									}

									return (
										<tr key={idx}>
											<td>
												{idx+1}. {el.name}
											</td>
											<td>
												{el.code}
											</td>
											<td>
												{el.qty}
											</td>
											<td className="checked-qty-wrapper">
												<input 
													type="number" 
													step="1" 
													value={el.checked_qty ?? ''} 
													onChange={e => setCheckedQty(idx, e.target.value)} 
													className="no-arrows" 
													readOnly={order.status !== 'review' && order.status !== 'unapproved'}
												/>
											</td>
											<td>
												{icon}
											</td>
										</tr>
									);
								})}
							</tbody>
							<tfoot>
								<tr>
									<td colSpan="3"></td>
									<td colSpan="2">
										{order.last_checked_at &&
											<>
												ACTUALIZADO: { moment(order.last_checked_at).format('DD-MM-YYYY / HH:mm') }
											</>
										}
									</td>
								</tr>
							</tfoot>
						</SubTable>
					</div>
					<div className="col-md-6 py-2">
						<div className="row">
							<div className="col-md-6">
								<div className="mb-2">
									<label>Albaran</label>
									<input 
										type="text" 
										className="form-control form-control-sm" 
										value={order.albaran ?? ''} 
										onChange={e => setOrder({...order, albaran: e.target.value})}
										readOnly={order.status !== 'review' && order.status !== 'unapproved'}
									/>
								</div>
							</div>
							<div className="col-md-6">
								<div className="mb-2">
									<label>Fecha Albarán</label>
									<input 
										type="date" 
										className="form-control form-control-sm" 
										value={order.albaran_date ? moment(order.albaran_date).format('YYYY-MM-DD') : ''} 
										onChange={e => setOrder({...order, albaran_date: e.target.value})}
										readOnly={order.status !== 'review' && order.status !== 'unapproved'}
									/>
								</div>
							</div>
						</div>

						{(order.status === 'review' || order.status === 'unapproved') &&
							<div>
								<button className="btn btn-primary btn-sm me-3" onClick={approve}>Aprobar</button>

								{ order.status === 'review' &&
									<button className="btn btn-danger btn-sm" onClick={cancel}>Cancelar</button>
								}
							</div>
						}

						{(order.sent_log && order.sent_at) &&
							<>
								<div className="mt-2">Respuesta de envío a BC: {moment(order.sent_at).format('DD-MM-YYYY / HH:mm')}</div>
								<div><small><span>gfu_GetPedido</span>: {order.sent_log['gfu_GetPedido']?.message ?? '-'}</small></div>
								<div><small><span>gfu_RegistrarPedido</span>: {order.sent_log['gfu_RegistrarPedido']?.message ?? '-'}</small></div>
							</>
						}
					</div>
				</div>
			</td>
		</tr>
	);
}


